import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import {config} from "../../../constant";
import {AppPieChart} from "../app";

export default function DialogGrandChampionStats({open, onClose}) {
    const [archivePeopleWithVictoriousYears, setArchivePeopleWithVictoriousYears] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${config.BASE_URL}/archive-ranks/grand-champion`)
            .then(response => response.json())
            .then(data => {
                setArchivePeopleWithVictoriousYears(data);
            })
            .catch((error) => {
                const message = 'Erreur dans la récupération des stats Grand Champion';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    }, []);

    return (
        archivePeopleWithVictoriousYears && (
            <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
                <DialogTitle>Stats Grand Champion</DialogTitle>
                <DialogContent>
                    {archivePeopleWithVictoriousYears.map(archivePersonStat => (
                        <Box key={archivePersonStat.id} sx={{mt: 1}}>
                            {archivePersonStat.firstName} : {archivePersonStat.victoriousYears.length} victoire{archivePersonStat.victoriousYears.length > 1 && 's'} ({archivePersonStat.victoriousYears.join(', ')})
                        </Box>
                    ))}
                    <AppPieChart sx={{mt: 3}}
                        chartData={archivePeopleWithVictoriousYears.map(archivePersonStat => {
                            return {
                                label: archivePersonStat.firstName,
                                value: archivePersonStat.victoriousYears.length
                            }
                        })}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>OK</Button>
                </DialogActions>
            </Dialog>
        )
    );
}
